module.exports = __webpack_public_path__ + "img/b2-4.9a3311a.png";